import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "@/plugins/i18n";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/pages/index.vue"),
    meta: { title: "router.home" },
  },
  {
    path: "/users",
    name: "Users",
    component: () => import("@/pages/users.vue"),
    meta: { title: "router.users" },
  },
  {
    path: "/users/address_list",
    name: "AddressList",
    component: () => import("@/pages/users.vue"),
    meta: { title: "router.addressList" },
  },
  {
    path: "/users/application_record",
    name: "ApplicationRecord",
    component: () => import("@/pages/users.vue"),
    meta: { title: "router.applicationRecord" },
  },
  {
    path: "/users/collection_list",
    name: "CollectionList",
    component: () => import("@/pages/users.vue"),
    meta: { title: "router.collectionList" },
  },
  {
    path: "/users/coupon_list",
    name: "CouponList",
    component: () => import("@/pages/users.vue"),
    meta: { title: "router.couponList" },
  },
  {
    path: "/users/evaluation_confirm",
    name: "EvaluationConfirm",
    component: () => import("@/pages/users.vue"),
    meta: { title: "router.evaluationConfirm" },
  },
  {
    path: "/users/evaluation_list",
    name: "EvaluationList",
    component: () => import("@/pages/users.vue"),
    meta: { title: "router.evaluationList" },
  },
  {
    path: "/users/invoice_list",
    name: "InvoiceList",
    component: () => import("@/pages/users.vue"),
    meta: { title: "router.invoiceList" },
  },
  {
    path: "/users/merchant_settled",
    name: "MerchantSettled",
    component: () => import("@/pages/users.vue"),
    meta: { title: "router.merchantSettled" },
  },
  {
    path: "/users/order_list",
    name: "OrderList",
    component: () => import("@/pages/users.vue"),
    meta: { title: "router.orderList" },
  },
  {
    path: '/users/after_sale',
    name: 'AfterSale',
    component: () => import("@/pages/users.vue"),
    meta: { title: "router.afterSale" },
  },
  {
    path: "/users/refund_confirm",
    name: "RefundConfirm",
    component: () => import("@/pages/users.vue"),
    meta: { title: "router.refundConfirm" },
  },
  {
    path: "/users/refund_list",
    name: "RefundList",
    component: () => import("@/pages/users.vue"),
    meta: { title: "router.refundList" },
  },
  {
    path: "/users/user_info",
    name: "UserInfo",
    component: () => import("@/pages/users.vue"),
    meta: { title: "router.userInfo" },
  },
  {
    path: "/users/wallet",
    name: "Wallet",
    component: () => import("@/pages/users.vue"),
    meta: { title: "router.wallet" },
  },
  {
    path: "/goods/activity_list",
    name: "ActivityList",
    component: () => import("@/pages/goods/activity_list.vue"),
    meta: { title: "router.activityList" },
  },
  {
    path: "/goods/goods_search",
    name: "GoodsSearch",
    component: () => import("@/pages/goods/goods_search.vue"),
    meta: { title: "router.goodsSearch" },
  },
  {
    path: "/goods/top_one",
    name: "TopOne",
    component: () => import("@/pages/goods/top_one.vue"),
    meta: { title: "router.topOne" },
  },
  {
    path: "/goods_detail/:id",
    name: "GoodsDetail",
    component: () => import("@/pages/goods_detail/_id/index.vue"),
    meta: { title: "router.goodsDetail" },
  },
  {
    path: "/merchant/merchant",
    name: "Merchant",
    component: () => import("@/pages/merchant/merchant.vue"),
    meta: { title: "router.merchant" },
  },
  {
    path: "/merchant/merchant_more",
    name: "MerchantMore",
    component: () => import("@/pages/merchant/merchant_more.vue"),
    meta: { title: "router.merchantMore" },
  },
  {
    path: "/merchant/merchant_street",
    name: "MerchantStreet",
    component: () => import("@/pages/merchant/merchant_street.vue"),
    meta: { title: "router.merchantStreet" },
  },
  {
    path: "/merchant/merchant/category",
    name: "MerchantCategory",
    component: () => import("@/pages/merchant/merchant/category.vue"),
    meta: { title: "router.merchantCategory" },
  },
  {
    path: "/merchant/merchant/coupon",
    name: "MerchantCoupon",
    component: () => import("@/pages/merchant/merchant/coupon.vue"),
    meta: { title: "router.merchantCoupon" },
  },
  {
    path: "/merchant/merchant/home",
    name: "MerchantHome",
    component: () => import("@/pages/merchant/merchant/home.vue"),
    meta: { title: "router.merchantHome" },
  },
  {
    path: "/merchant/merchant/qualification",
    name: "MerchantQualification",
    component: () => import("@/pages/merchant/merchant/qualification.vue"),
    meta: { title: "router.merchantQualification" },
  },
  {
    path: "/middlewares/callback_twitter",
    name: "CallbackTwitter",
    component: () => import("@/pages/middlewares/callback_twitter.vue"),
    meta: { title: "router.callbackTwitter" },
  },
  {
    path: "/middlewares/privacy_agreement",
    name: "PrivacyAgreement",
    component: () => import("@/pages/middlewares/privacy_agreement.vue"),
    meta: { title: "router.privacyAgreement" },
  },
  {
    path: "/middlewares/about",
    name: "About",
    component: () => import("@/pages/middlewares/about.vue"),
    meta: { title: "router.about" },
  },
  {
    path: "/middlewares/contact",
    name: "Contact",
    component: () => import("@/pages/middlewares/contact.vue"),
    meta: { title: "router.contact" },
  },
  {
    path: "/order/order_confirm",
    name: "OrderConfirm",
    component: () => import("@/pages/order/order_confirm.vue"),
    meta: { title: "router.orderConfirm" },
  },
  {
    path: "/order/order_confirmNoLogin",
    name: "OrderConfirmNoLogin",
    component: () => import("@/pages/order/order_confirmNoLogin.vue"),
    meta: { title: "router.orderConfirm" },
  },
  {
    path: "/order/order_detail",
    name: "OrderDetail",
    component: () => import("@/pages/order/order_detail.vue"),
    meta: { title: "router.orderDetail" },
  },
  {
    path: "/order/payment_result",
    name: "PaymentResult",
    component: () => import("@/pages/order/payment_result.vue"),
    meta: { title: "router.paymentResult" },
  },
  {
    path: "/order/refund_detail",
    name: "RefundDetail",
    component: () => import("@/pages/order/refund_detail.vue"),
    meta: { title: "router.refundDetail" },
  },
  {
    path: "/order/shopping_cart",
    name: "ShoppingCart",
    component: () => import("@/pages/order/shopping_cart.vue"),
    meta: { title: "router.shoppingCart" },
  },
  {
    path: "/order/stripe_payment",
    name: "StripePayment",
    component: () => import("@/pages/order/stripe_payment.vue"),
    meta: { title: "router.stripePayment" },
  },
  {
    path: "/news",
    name: "News",
    component: () => import("@/pages/news/index.vue"),
    meta: { title: "router.news" },
  },
  {
    path: "/news/detail/:id",
    name: "NewsDetail",
    component: () => import("@/pages/news/detail/_id/index.vue"),
    meta: { title: "router.newsDetail" },
  },
  {
    path: "/trackOrder",
    name: "trackOrder",
    component: () => import("@/pages/order/trackOrder.vue"),
    meta: { title: "router.trackOrder" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  // 根据路由元信息设置页面标题，使用 i18n 翻译
  if (to.meta.title) {
    document.title = i18n.t(to.meta.title);
  }
  next();
});

export default router;
